/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ProtectedGcpWorkloadsStore } from '../stores/ProtectedGcpWorkloadsStore';

export const ProtectedGcpWorkloadsContext = createContext<ProtectedGcpWorkloadsStore>({} as ProtectedGcpWorkloadsStore);
